import { setupI18n } from '@lingui/core';
import { mergeCatalogs, sdkCatalog } from '@salsita-ai/platform-project-sdk/i18n';
import { messages as en } from './locales/en/messages.js';
import { messages as fr } from './locales/fr/messages.js';
import { messages as nl } from './locales/nl/messages.js';
export const catalog = {
    nl,
    fr,
    en
};
export const availableLocales = Object.keys(catalog);
const messages = mergeCatalogs([
    sdkCatalog,
    catalog
]);
export const createI18n = ()=>setupI18n({
        messages,
        locale: 'nl'
    });

//# sourceMappingURL=index.js.map